import {
  combineReducers
} from 'redux'
import orm from './orm'

export default combineReducers({
  orm
})
